import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import {
  energiaGeradaInversoresChartDataFromEnergiaGeradaInversores,
  generateColorArray,
} from "./GeneratedEnergyCharts";
import {
  numberPtBr,
  numberPtBrPercent0100,
} from "../../../../main/utils/utils";
import { EmptyTable } from "../../../clients/components/EmptyState";
import {
  EnergiaGeradaInversoresMediaHoraria,
  EnergiaGeradaInversoresMes,
} from "../../types";

export default function UnitPerformanceChart(
  data: EnergiaGeradaInversoresMediaHoraria | EnergiaGeradaInversoresMes
) {
  const energiaGeradaInversoresChartData =
    energiaGeradaInversoresChartDataFromEnergiaGeradaInversores(data);

  const options: EChartsOption = {
    title: {
      text: "Energia Gerada por skid (MWh)",
      textStyle: {
        fontSize: 12,
      },
    },
    backgroundColor: "transparent",
    color: generateColorArray(
      energiaGeradaInversoresChartData.listaPerformanceUnidadeGeradora.length ??
      0
    ),
    series: [
      {
        name: "Energia Gerada por skid (MWh)",
        type: "pie",
        radius: "85%",
        center: ["50%", "55%"],
        itemStyle: {
          borderRadius: 8,
          borderColor: "transparent",
          borderWidth: 2,
        },
        label: {
          position: "inner",
          rotate: -30,
          formatter(v) {
            const { name, percent, value } = v;
            const vTxt =
              typeof value === "number" ? numberPtBr(value, 2) : `${value}`;
            const percentageTxt = numberPtBrPercent0100(percent ?? 0, 1);
            return `${name} \n ${vTxt} MW (${percentageTxt})`;
          },
        },
        percentPrecision: 2,

        data: energiaGeradaInversoresChartData.listaPerformanceUnidadeGeradora.map(
          (item) => ({
            value: item.energiaGeradaMWh,
            name: item.name,
          })
        ),
      },
    ],
  };

  const hasData =
    energiaGeradaInversoresChartData.listaPerformanceUnidadeGeradora.length ??
      0 > 0
      ? true
      : false;

  return (
    <>
      {hasData ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90%",
            width: "100%",
          }}
        >
          <RopChart option={options} />
        </Container>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title="Nenhum dado encontrado!" />
        </Box>
      )}
    </>
  );
}
